import React, { useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";

const FrontHeader = () => {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();

  const Icons = {
    Shop: () => (
      <svg
        className="w-6 h-6 text-white"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"
        />
      </svg>
    ),
    Mobile: () => (
      <svg
        className="w-4 h-4 text-brand-orange/60"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z"
        />
      </svg>
    ),
    Dot: ({ color = "text-green-500" }) => (
      <svg
        className={`w-3 h-3 ${color}`}
        fill="currentColor"
        viewBox="0 0 20 20"
      >
        <path
          fillRule="evenodd"
          d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-11a1 1 0 10-2 0v2H7a1 1 0 100 2h2v2a1 1 0 102 0v-2h2a1 1 0 100-2h-2V7z"
          clipRule="evenodd"
        />
      </svg>
    ),
    Close: () => (
      <svg
        className="w-6 h-6 text-brand-dark"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M6 18L18 6M6 6l12 12"
        />
      </svg>
    ),
    Menu: () => (
      <svg
        className="w-6 h-6 text-brand-dark"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M4 6h16M4 12h16M4 18h16"
        />
      </svg>
    ),
  };

 const navLinks = [
  { name: "About Us", path: "/about-us" },
  { name: "Contact Us", path: "/contact-us" },
  { name: "For Owners", path: "/for-owner" },
  { name: "For Customers", path: "/for-customer" },
];


  return (
    <div>
      <nav className="w-full bg-brand-body/95 backdrop-blur-sm sticky top-0 z-50 border-b border-gray-100">
        <div className="w-full mx-auto py-4 px-6 md:px-16 flex items-center justify-between">
          {/* Logo Section */}
          <div
            className="flex items-center gap-2 cursor-pointer"
            onClick={() => {
              navigate("/");
            }}
          >
            <div className="bg-brand-orange p-1.5 rounded-lg cursor-pointer">
              <Icons.Shop />
            </div>
            <span className="text-xl md:text-2xl font-extrabold tracking-tight text-brand-dark">
              Dukaan<span className="text-brand-orange">Setu</span>
            </span>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center gap-8 text-sm font-semibold text-gray-700">
            {navLinks.map((link) => (
              <Link
                key={link.name}
                to={link.path}
                className="hover:text-brand-orange transition-colors"
              >
                {link.name}
              </Link>
            ))}
          </div>

          {/* Desktop Buttons */}
          <div className="hidden lg:flex items-center gap-4">
            <button
              className="btn-primary"
              type="button"
              onClick={() => navigate("/login")}
            >
              Log In
            </button>
            <button
              className="btn-primary"
              onClick={() => navigate("/customer-register")}
            >
              Get Started Free
            </button>
          </div>

          {/* Mobile Menu Button */}
          <div className="lg:hidden">
            <button
              onClick={() => setIsOpen(!isOpen)}
              className="text-brand-dark p-2 focus:outline-none"
            >
              {isOpen ? <Icons.Close /> : <Icons.Menu />}
            </button>
          </div>
        </div>

        {/* Mobile Menu Dropdown */}
        <div
          className={`lg:hidden transition-all duration-300 ease-in-out ${isOpen ? "max-h-screen opacity-100 border-t border-gray-100" : "max-h-0 opacity-0 overflow-hidden"}`}
        >
          <div className="flex flex-col space-y-4 px-6 py-6 bg-brand-body">
            {navLinks.map((link) => (
              <Link
                key={link.name}
                to={link.path}
                className="text-lg font-semibold text-gray-700 hover:text-brand-orange"
                onClick={() => setIsOpen(false)}
              >
                {link.name}
              </Link>
            ))}
            <hr className="border-gray-100" />
            <div className="flex flex-col gap-4">
              <button
                className="text-brand-dark font-bold px-4 py-2 hover:text-brand-orange transition-colors w-full justify-center"
                onClick={() => navigate("/login")}
              >
                Log In
              </button>
              <button className="btn-primary w-full justify-center">
                Get Started Free
              </button>
            </div>
          </div>
        </div>
      </nav>
    </div>
  );
};

export default FrontHeader;
